class BlanksProductManager {
constructor() {
    this.selectedColor = null;
    this.quantities = {};
    this.productsData = {};
    this.variantStocks = {};
    this.mainImage = document.getElementById('mainProductImage');
    this.colorMap = {
"Aqua": "rgb(66, 152, 181)",
 "Light Silver": "rgb(217, 219, 215)",
"Heather Forest Green": "rgb(69, 99, 93)",
"Neon Heather Green": "rgb(171, 255, 126)",
"Silk": "rgb(202, 192, 191)",
"Heather Redwood": "rgb(180, 89, 73)",
"Warm Grey": "rgb(139, 131, 119)",
"Heather Light Pink": "rgb(244, 206, 204)",
"Cardinal Blackout": "rgb(150, 36, 47)",
"Bermuda Blackout": "rgb(70, 107, 127)",
"Blended White": "rgb(240, 243, 246)",
"Bamboo Blackout": "rgb(103, 107, 95)",
"Basil": "rgb(84, 116, 110)",
"Coyote Brown": "rgb(166, 126, 85)",
"Heather Slate Blue": "rgb(94, 112, 126)",
"Stone Grey": "rgb(156, 150, 141)",
"Light Olive": "rgb(124, 119, 87)",
"Heather Heavy Metal": "rgb(117, 107, 114)",
"Vintage Coyote Brown": "rgb(151, 107, 74)",
"Wisteria Blackout": "rgb(122, 105, 126)",
"Vintage Burgundy": "rgb(161, 75, 87)",
"Vintage True Navy": "rgb(64, 76, 110)",
"Vintage Orange": "rgb(230, 106, 60)",
"Vintage Indigo": "rgb(103, 120, 150)",
"Vintage Hot Pink": "rgb(230, 71, 114)",
"Vintage Green": "rgb(42, 131, 71)",
"Vintage Smoke": "rgb(84, 78, 80)",
"Vintage Military Green": "rgb(143, 129, 90)",
"Pro Purple": "rgb(94, 38, 120)",
"Rouge": "rgb(176, 85, 96)",
"Surf Blackout": "rgb(94, 126, 129)",
"Oceanside": "rgb(23, 107, 119)",
"Honeydew": "rgb(222, 233, 219)",
"Tradewind": "rgb(69, 148, 212)",
"Papaya": "rgb(240, 127, 92)",
"Latte": "rgb(205, 172, 133)",
"Porcelain": "rgb(236, 230, 222)",
"Passionfruit": "rgb(220, 80, 70)",
"Apple": "rgb(123, 172, 80)",
"Ballerina": "rgb(250, 219, 225)",
"Natural Heather": "rgb(238, 230, 227)",
"Granite Heather": "rgb(108, 109, 111)",
"Washed Navy": "rgb(55, 78, 110)",
"Saltwater": "rgb(159, 212, 203)",
"Titanium": "rgb(194, 190, 186)",
"Heather": "rgb(151, 153, 155)",
"Mauvelous": "rgb(217, 127, 129)",
"Caribbean": "rgb(83, 196, 203)",
"Key Lime": "rgb(195, 210, 140)",
"Chill": "rgb(170, 220, 209)",
 "Dark Heather Grey": "rgb(112, 114, 115)",
 "Purple Berry": "rgb(124, 85, 128)",
"Lush": "rgb(197, 72, 143)",
 "Shiitake": "rgb(186, 172, 168)",
"Antique Denim": "rgb(94, 110, 116)",
"Graphite Black": "rgb(54, 53, 56)",
"Lead Grey": "rgb(163, 158, 160)",
"Oxblood": "rgb(77, 43, 46)",
"Black/ Black": "rgb(33, 35, 39)",
"Smoked Paprika": "rgb(217, 126, 122)",
"Light Grey": "rgb(197, 191, 186)",
"Vintage Heavy Metal": "rgb(94, 91, 91)",
"Black Forest": "rgb(64, 78, 69)",
"Vintage Stonewash Denim": "rgb(172, 187, 198)",
"Legion Blue": "rgb(66, 78, 99)",
"Cardinal Black": "rgb(77, 43, 46)",
"Classic Orange": "rgb(255, 87, 0)",
"Heather Metal": "rgb(81, 82, 83)",
"Royal Pine": "rgb(74, 102, 98)",
"Shiraz": "rgb(150, 89, 122)",
"Stonewash Denim": "rgb(172, 187, 198)",
"Stonewash Green": "rgb(180, 202, 199)",
"Galaxy Purple": "rgb(92, 79, 117)",
"Envy": "rgb(0, 178, 107)",
"Heather Cool Blue": "rgb(77, 107, 160)",
"Bondi Blue": "rgb(0, 153, 178)",
"Apple Green": "rgb(150, 206, 133)",
"Banana Cream": "rgb(240, 209, 131)",
"Desert Pink": "rgb(240, 206, 199)",
"Hot Pink": "rgb(238, 102, 126)",
"Heavy Metal": "rgb(68, 70, 70)",
"Vibrant Yellow": "rgb(240, 206, 95)",
"Cancun": "rgb(112, 206, 222)",
"Raspberry": "rgb(220, 37, 107)",
"Light Orange": "rgb(255, 169, 109)",
"Antique Gold": "rgb(186, 128, 0)",
"Heather Grape": "rgb(125, 87, 126)",
"Heather Nephrite": "rgb(151, 179, 87)",
"Heather Super Pink": "rgb(197, 49, 137)",
"Heather Khaki": "rgb(191, 184, 167)",
"Heather Panna Cotta": "rgb(244, 237, 187)",
"Heather Light Blue": "rgb(191, 215, 238)",
"Heather Sea Blue": "rgb(84, 107, 140)",
"Heather Lilac": "rgb(217, 203, 221)",
"Heather Royal Blue": "rgb(66, 92, 169)",
"Vintage Lilac": "rgb(226, 172, 199)",
"Vintage Turquoise": "rgb(0, 169, 203)",
"Vintage Shocking Pink": "rgb(226, 73, 119)",
"Vintage Royal": "rgb(66, 92, 169)",
"Vintage Pink": "rgb(240, 113, 166)",
"Vintage Purple": "rgb(117, 79, 105)",
"Vintage Light Orange": "rgb(242, 189, 160)",
"Venetian Grey": "rgb(139, 134, 126)",
"Purple Rush": "rgb(104, 76, 148)",
"Tahiti Blue": "rgb(114, 212, 216)",
"Envy": "rgb(0, 178, 107)",
"Desert Pink": "rgb(240, 206, 199)",
"Premium Heather": "rgb(156, 158, 161)",
"Heather White": "rgb(235, 235, 235)",
"Macchiato": "rgb(117, 96, 97)",      
"Heather Teal": "rgb(49, 178, 203)",
"Heather Celadon": "rgb(172, 222, 215)",
"Powder Blue": "rgb(203, 215, 230)",
"Royal Blue": "rgb(30, 93, 182)",
"Super Pink": "rgb(198, 49, 137)",
"Panna Cotta": "rgb(243, 236, 187)",
"New Silver": "rgb(221, 219, 218)",
"Eggplant": "rgb(94, 76, 102)",
"Sea Spray": "rgb(200, 226, 224)",
"Nephrite": "rgb(151, 179, 87)",
"Smokey Violet": "rgb(186, 159, 172)",
"Sea Blue": "rgb(66, 92, 122)",
"Cranberry": "rgb(172, 33, 58)",
"Blush": "rgb(235, 196, 195)",
"Canyon": "rgb(201, 99, 90)",
"Arctic": "rgb(117, 146, 147)",
"Heather Coral": "rgb(229, 89, 78)",
"Heather Blush": "rgb(241, 206, 204)",
"Heather Eggplant": "rgb(94, 76, 102)",
"Heather Cucumber": "rgb(221, 227, 213)",
"Heather Canyon": "rgb(201, 99, 90)",
"Heather Bone": "rgb(227, 218, 199)",
"Heather Cranberry": "rgb(150, 60, 84)",
"Heather Arctic": "rgb(130, 187, 184)",
"Heather Army": "rgb(113, 98, 77)",
"Heather Asphalt": "rgb(69, 68, 66)",
"Heather Cream": "rgb(238, 230, 216)",
"Heather Light Mint": "rgb(175, 232, 196)",
"Heather Light Sage": "rgb(139, 166, 155)",
"Heather Light Silver": "rgb(217, 219, 215)",
"Heather Navy Blue": "rgb(54, 69, 92)",
"Heather Vintage Natural": "rgb(238, 230, 216)",
"Heather Black": "rgb(36, 36, 36)",
"Heather Olive Green": "rgb(140, 137, 91)",
"Heather Deep Purple": "rgb(109, 92, 122)",
"Purist Blue": "rgb(186, 230, 239)",
"Grape Leaf": "rgb(84, 85, 59)",
"Inked India": "rgb(48, 59, 87)",
"Cream": "rgb(244, 238, 225)",
"Light Mint": "rgb(175, 232, 196)",
"Light Sage": "rgb(139, 166, 155)",
"Olive Green": "rgb(98, 102, 59)",
"Navy Blue": "rgb(54, 69, 92)",
"Vintage Natural": "rgb(244, 238, 225)",
"Aqua Triblend": "rgb(0, 158, 196)",
"Heather Rust": "rgb(187, 98, 59)",
"Indigo": "rgb(68, 93, 123)",
"Sunshine": "rgb(255, 222, 107)",
"Heather Purist Blue": "rgb(186, 230, 239)",
"Heather Denim": "rgb(68, 93, 123)",
"Heather Graphite": "rgb(74, 80, 89)",
"Heather Mellow Yellow": "rgb(249, 187, 68)",
"Neo Mint": "rgb(202, 237, 194)",
"Heather Neo Mint": "rgb(202, 237, 194)",
"Camel": "rgb(186, 137, 85)",
"Sand (disc)": "rgb(137, 117, 72)",
"Royal (disc)": "rgb(2, 66, 140)",
"Lemon": "rgb(255, 222, 107)",
"Heather Grey": "rgb(176, 178, 179)",
"Cassis": "rgb(193, 110, 137)",
"Heather Cantaloupe": "rgb(255, 179, 142)",
"Heather Hunter": "rgb(84, 91, 82)",
"Heather Royal (disc)": "rgb(69, 106, 178)",
"Buttercream": "rgb(248, 237, 215)",
"Lavender": "rgb(214, 203, 231)",
"Heather Athletic Blue": "rgb(175, 203, 227)",
"Heather Purple (disc)": "rgb(118, 97, 126)",
"Ginger": "rgb(217, 155, 61)",
"Heather Burgundy": "rgb(148, 77, 85)",
"Burgundy": "rgb(94, 49, 63)",
"Coal": "rgb(55, 60, 64)",
"Cantaloupe": "rgb(255, 179, 142)",
"Heather Cassis": "rgb(193, 110, 137)",
"Heather Charcoal": "rgb(74, 80, 89)",
      "Safari": "rgb(120, 100, 80)",
"Retro Heather Coral": "rgb(255, 140, 100)",
"Oatmeal Heather": "rgb(235, 225, 215)",
"Golden Pecan": "rgb(180, 120, 70)",
"Chocolate": "rgb(70, 55, 50)",
      "Washed Navy": "rgb(68, 93, 123)",
"Sweet Cream Heather": "rgb(240, 235, 227)",
"Sunset Coral": "rgb(255, 122, 97)",
"Soul Blue": "rgb(108, 206, 255)",
"Periwinkle Blue": "rgb(137, 153, 203)",
      "Charcoal Grey": "rgb(60, 60, 70)",
"California Blue": "rgb(0, 180, 215)",
      "Vintage Heather Red": "rgb(192, 100, 100)",
"Vintage Heather Navy": "rgb(68, 77, 94)",
"Vintage Heather Maroon": "rgb(128, 64, 76)",
"Vintage Heather Blue": "rgb(80, 95, 120)",
"Jade": "rgb(0, 160, 140)",
"Island Yellow": "rgb(255, 190, 0)",
"Irish Green Heather": "rgb(0, 160, 110)",
"Cyber Pink": "rgb(200, 50, 120)",
"Cool Mint": "rgb(180, 240, 210)",
"Classic Pink": "rgb(230, 195, 195)",
      "Aquatic Blue": "rgb(93, 188, 210)",
"Mint To Be": "rgb(189, 252, 201)",
"Limestone": "rgb(220, 224, 217)",
"Deep Emerald": "rgb(0, 102, 102)",
"Butterscotch": "rgb(238, 187, 81)",
"Bubblegum": "rgb(255, 193, 204)",
      "Breezy Blue": "rgb(204, 238, 255)",
      "Vintage Heather Orange": "rgb(208, 93, 73)",
"Taupe Heather": "rgb(178, 155, 143)",
"Simply Aqua Heather": "rgb(127, 219, 219)",
"Scuba Blue": "rgb(64, 192, 185)",
"Retro Heather Royal": "rgb(80, 100, 160)",
"Raspberry Heather": "rgb(208, 65, 90)",
"Oxford": "rgb(120, 120, 120)",
"Mustard Heather": "rgb(218, 175, 48)",
"Maroon Heather": "rgb(98, 48, 60)",
"Forest Green Heather": "rgb(48, 67, 60)",
      "Fiery Red Heather": "rgb(230, 70, 70)",
"Digital Teal Heather": "rgb(40, 100, 105)",
"Denim Heather": "rgb(100, 110, 145)",
"Deep Purple": "rgb(70, 30, 95)",
"Charcoal Heather": "rgb(90, 90, 90)",
"Carolina Heather": "rgb(150, 190, 220)",
  "Army": "rgb(85, 87, 76)",
  "Ash": "rgb(178, 190, 181)",
  "Asphalt": "rgb(108, 104, 100)",
  "Asphalt Slub": "rgb(84, 88, 90)",
      "True Red": "rgb(187, 22, 33)",
"Soul Blue Heather": "rgb(74, 185, 233)",
"Rock": "rgb(187, 183, 184)",
"Putty": "rgb(208, 198, 186)",
"Military Green Heather": "rgb(109, 110, 96)",
"J. Navy": "rgb(35, 45, 68)",
"Indigo Heather": "rgb(71, 80, 88)",
"Celery Juice": "rgb(238, 239, 207)",
"Blush Pink": "rgb(243, 224, 219)",
"Black Ink Heather": "rgb(77, 79, 81)",
      "Black Ink": "rgb(43, 45, 48)",
        "White/ Black": "rgb(225, 225, 225)",
      "Sunset Triblend": "rgb(222, 163, 148)",
      "Mauve Triblend": "rgb(193, 131, 128)",
      "Stone Marble": "rgb(175, 168, 151)",
"Peach Slub": "rgb(230, 196, 182)",
"Olive Slub": "rgb(119, 108, 95)",
"Natural Slub": "rgb(235, 229, 210)",
"Mauve Slub": "rgb(180, 137, 133)",
"Denim Triblend": "rgb(125, 142, 149)",
"Brick Triblend": "rgb(175, 52, 14)",
"Black Heather Triblend": "rgb(55, 53, 54)",
      "DTG White": "rgb(243, 243, 247)",
"DTG Dark Grey": "rgb(51, 51, 51)",
"DTG Black": "rgb(33, 33, 33)",
      "Yellow Gold Triblend": "rgb(243, 185, 52)",
"Tan Triblend": "rgb(193, 175, 161)",
"Steel Blue Triblend": "rgb(108, 126, 136)",
"Solid True Royal Triblend": "rgb(94, 91, 161)",
"Solid Team Purple Triblend": "rgb(69, 29, 93)",
"Solid Slate Triblend": "rgb(107, 120, 129)",
"Solid Silver Triblend": "rgb(209, 209, 209)",
"Solid Red Triblend": "rgb(213, 22, 49)",
"Solid Orange Triblend": "rgb(255, 80, 25)",
"Solid Maroon Triblend": "rgb(122, 36, 51)",
      "Solid Kelly Triblend": "rgb(25, 96, 62)",
"Solid Gold Triblend": "rgb(255, 179, 41)",
"Solid Forest Triblend": "rgb(72, 85, 76)",
"Solid Carolina Blue Triblend": "rgb(126, 172, 218)",
"Solid Blue Triblend": "rgb(125, 142, 181)",
"Solid Asphalt Triblend": "rgb(105, 105, 105)",
"Sea Green Triblend": "rgb(94, 211, 194)",
"Sand Dune Triblend": "rgb(231, 207, 191)",
"Peach Triblend": "rgb(231, 185, 166)",
"Orchid Triblend": "rgb(203, 160, 161)",
      "Mint Triblend": "rgb(220, 240, 218)",
      "Blue Storm Triblend": "rgb(128, 137, 140)",
"Military Green Triblend": "rgb(117, 121, 105)",
"Lilac Triblend": "rgb(221, 195, 213)",
"Ice Blue Triblend": "rgb(227, 243, 246)",
"Grass Green Triblend": "rgb(94, 107, 85)",
"Peri Blue": "rgb(120, 142, 190)",
"Bone": "rgb(243, 237, 232)",  
"Espresso Triblend": "rgb(79, 72, 69)",
"Dark Lavender Triblend": "rgb(193, 184, 213)",
"Cement Triblend": "rgb(224, 220, 217)",
"Cardinal Triblend": "rgb(127, 65, 66)",
"Brown Triblend": "rgb(110, 95, 87)",
"Storm Triblend": "rgb(181, 178, 184)",
"Spring Green Triblend": "rgb(226, 230, 196)",
"Solid White Triblend": "rgb(247, 247, 247)",
"Solid Navy Triblend": "rgb(50, 52, 61)",
"Solid Natural Triblend": "rgb(242, 234, 225)",
"Solid Dark Grey Triblend": "rgb(69, 69, 73)",
"Solid Black Triblend": "rgb(41, 41, 41)",
"Red Triblend": "rgb(217, 89, 84)",
"Pink Triblend": "rgb(249, 199, 196)",
      "Pale Yellow Triblend": "rgb(248, 227, 171)",
"Olive Triblend": "rgb(148, 134, 102)",
"Mustard Triblend": "rgb(222, 155, 33)",
"Kelly Triblend": "rgb(64, 122, 98)",
"Dusty Blue Triblend": "rgb(182, 199, 195)",
"Charity Pink Triblend": "rgb(255, 110, 142)",
"Bright Salmon": "rgb(249, 102, 85)",
"Boysenberry": "rgb(187, 39, 122)",
"Blue Jean": "rgb(84, 99, 126)",
        "Antique Jade Dome": "rgb(0, 128, 134)",
         "Dark Grey/ Black": "rgb(53, 48, 54)",
      "Pistachio": "rgb(226, 240, 203)",
"Paragon": "rgb(193, 173, 178)",
      "Vegas Gold": "rgb(224, 206, 172)",
"PFD White": "rgb(240, 240, 240)",
"Metro Blue": "rgb(77, 86, 115)",
"Heather Indigo": "rgb(137, 148, 158)",
"Galapagos Blue": "rgb(2, 102, 118)",
"Antique Royal": "rgb(29, 74, 182)",
"Smoke": "rgb(88, 81, 78)",
"Iris": "rgb(75, 124, 182)",
"Lagoon Blue": "rgb(100, 209, 219)",
"Pink Lemonade": "rgb(253, 116, 155)",
      "Prairie Dust": "rgb(126, 118, 97)",
"Ash Grey": "rgb(204, 204, 204)",
"Stone Blue": "rgb(154, 169, 179)",
       "Charcoal Black Triblend/ Solid Black Triblend": "rgb(62, 61, 66)",
             "Black/ Athletic Heather": "rgb(33, 31, 35)",
              "Antique Irish Green": "rgb(0, 138, 76)",
  "Athletic Grey Triblend": "rgb(137, 141, 141)",
      "Tangerine Mist": "rgb(251, 173, 116)",
      "Kelly Mist": "rgb(22, 160, 93)",
"Gunmetal": "rgb(132, 136, 132)",
"Dune Mist": "rgb(181, 164, 131)",
"Daisy Mist": "rgb(249, 222, 120)",
"Cocoa Mist": "rgb(161, 103, 93)",
"Carolina Blue Mist": "rgb(106, 146, 179)",
      "Yam": "rgb(199, 114, 47)",
"Wine": "rgb(148, 119, 126)",
"Watermelon": "rgb(249, 99, 107)",
"Washed Denim": "rgb(161, 178, 191)",
"True Navy": "rgb(42, 53, 72)",
"Seafoam": "rgb(92, 149, 140)",
"Sandstone": "rgb(151, 142, 129)",
"Royal Caribe": "rgb(31, 95, 140)",
"Periwinkle": "rgb(147, 148, 192)",
"Pepper": "rgb(86, 84, 83)",
"Peachy": "rgb(254, 214, 198)",
"Paprika": "rgb(255, 46, 83)",
"Neon Violet": "rgb(222, 185, 255)",
"Neon Red Orange": "rgb(255, 114, 95)",
"Neon Lemon": "rgb(248, 245, 189)",
"Neon Cantaloupe": "rgb(255, 204, 150)",
"Mystic Blue": "rgb(117, 128, 184)",
"Moss": "rgb(125, 131, 113)",
"Melon": "rgb(255, 123, 44)",
"Light Green": "rgb(108, 126, 114)",
      "Lagoon": "rgb(77, 167, 179)",
"Khaki": "rgb(194, 178, 154)",
"Ivory": "rgb(242, 233, 224)",
"Island Reef": "rgb(180, 223, 202)",
"Island Green": "rgb(32, 178, 170)",
"Hydrangea": "rgb(212, 228, 237)",
"Hemp": "rgb(90, 86, 68)",
"Graphite": "rgb(81, 84, 91)",
"Grape": "rgb(132, 116, 139)",
"Flo Blue": "rgb(95, 115, 171)",
      "Crunchberry": "rgb(201, 74, 115)",
"Crimson": "rgb(157, 41, 51)",
"Citrus": "rgb(237, 163, 43)",
"China Blue": "rgb(105, 122, 148)",
      "Heather Dark Grey": "rgb(118, 118, 118)",
"Chili": "rgb(148, 42, 52)",
"Chambray": "rgb(209, 219, 221)",
"Chalky Mint": "rgb(148, 201, 184)",
"Butter": "rgb(249, 220, 139)",
"Bright Orange": "rgb(255, 117, 0)",
"Blue Spruce": "rgb(47, 79, 79)",
      "Blossom": "rgb(228, 182, 192)",
"Bay": "rgb(203, 206, 193)",
"Banana": "rgb(238, 222, 176)",
      "Grass": "rgb(83, 148, 109)",
"Celadon": "rgb(217, 221, 181)",
"Cumin": "rgb(219, 122, 118)",
"Caribbean Mist": "rgb(0, 169, 206)",
"Cactus": "rgb(139, 141, 108)",
"Amethyst": "rgb(128, 82, 142)",
"Royal Mist": "rgb(77, 114, 184)",
"Red Mist": "rgb(204, 3, 3)",
"Plumrose": "rgb(234, 184, 187)",
"Pitch Black Mist": "rgb(81, 78, 82)",
"Pitch Black": "rgb(45, 43, 46)",
"Pink Lemonade Mist": "rgb(254, 115, 149)",
"Navy Mist": "rgb(79, 88, 114)",
"Maroon Mist": "rgb(117, 49, 58)",
"Light Blue Mist": "rgb(212, 227, 239)",
  "Athletic Heather": "rgb(172, 177, 166)",
       "Athletic Heather/ Navy": "rgb(183, 183, 183)",
      "Deep Heather/ Black": "rgb(110, 114, 117)",
      "Brown Savana": "rgb(165, 136, 122)",
"Blue Dusk": "rgb(60, 71, 89)",
"Blackberry": "rgb(59, 50, 81)",
      "Green Triblend": "rgb(114, 190, 132)",
"Aquatic": "rgb(102, 152, 143)",
"Antique Orange": "rgb(203, 75, 43)",
      "Dusty Rose": "rgb(234, 187, 170)",
"Cornsilk": "rgb(251, 231, 140)",
"Coral Silk": "rgb(254, 104, 111)",
"Cobalt": "rgb(47, 56, 133)",
      "Kiwi": "rgb(166, 193, 116)",
"Ice Grey": "rgb(224, 213, 212)",
"Heather Sapphire": "rgb(55, 160, 203)",
"Heather Radiant Orchid": "rgb(220, 135, 200)",
"Yellow Haze": "rgb(254, 218, 155)", 
"Tweed": "rgb(90, 94, 97)", 
"Turf Green": "rgb(8, 135, 74)", 
"Tropical Blue": "rgb(0, 157, 176)", 
"Tangerine": "rgb(254, 155, 118)", 
"Sky": "rgb(151, 213, 233)", 
"Russet": "rgb(85, 64, 61)", 
"Off White": "rgb(240, 235, 216)", 
  "Atlantic": "rgb(17, 59, 64)",
  "Autumn": "rgb(156, 83, 49)",
  "Baby Blue": "rgb(131, 176, 193)",
  "Berry": "rgb(195, 22, 124)",
  "Berry Triblend": "rgb(172, 20, 90)",
  "Black": "rgb(0, 0, 0)",
  "Black Heather": "rgb(69, 64, 56)",
  "Black Marble": "rgb(42, 40, 41)",
  "Black Mineral Wash": "rgb(37, 40, 42)",
  "Black Slub": "rgb(37, 40, 42)",
  "Black Speckled": "rgb(45, 41, 38)",
  "Blue Marble": "rgb(112, 167, 208)",
  "Blue Triblend": "rgb(110, 142, 192)",
  "Brick": "rgb(151, 58, 54)",
  "Brown": "rgb(165, 42, 42)",
  "Bubble Gum": "rgb(248, 163, 188)",
  "Burnt Orange": "rgb(203, 96, 21)",
  "Canvas Red": "rgb(157, 34, 53)",
  "Cardinal": "rgb(155, 39, 67)",
"Cocoa": "rgb(91, 74, 66)",
"Carolina Blue": "rgb(123, 175, 212)",
"Cement": "rgb(210, 207, 196)",
"Charcoal": "rgb(54, 69, 79)",
"Charcoal Black Triblend": "rgb(61, 57, 53)",
"Charity Pink": "rgb(223, 103, 151)",
"Chestnut": "rgb(138, 75, 50)",
"Citron": "rgb(221, 227, 213)",
"Clay": "rgb(162, 104, 89)",
"Clay Triblend": "rgb(125, 43, 39)",
"Columbia Blue": "rgb(85, 113, 164)",
"Cool Blue": "rgb(1, 66, 106)",
"Cool Grey": "rgb(196, 188, 183)",
"Coral": "rgb(248, 124, 86)",
"Currant": "rgb(171, 52, 117)",
"Dark Grey": "rgb(169, 169, 169)",
"Dark Grey Heather": "rgb(82, 86, 87)",
"Dark Heather": "rgb(116, 116, 116)",
"Dark Lavender": "rgb(155, 145, 190)",
 "Dark Olive": "rgb(54, 54, 45)",
"Deep Heather": "rgb(117, 114, 111)",
"Deep Heather Speckled": "rgb(106, 104, 101)",
"Deep Teal": "rgb(0, 89, 122)",
"Denim": "rgb(75, 128, 140)",
"Dust": "rgb(205, 198, 189)",
"Dusty Blue": "rgb(155, 178, 162)",
"Dark Maroon": "rgb(92, 49, 58)",
"Dark Green": "rgb(50, 71, 54)",
"Daisy": "rgb(250, 207, 68)",
"Jade Dome": "rgb(1, 133, 138)",
"Gravel": "rgb(178, 172, 174)",
"Electric Green": "rgb(104, 197, 90)",
"Deep Royal": "rgb(28, 62, 134)",
"Dark Navy": "rgb(51, 54, 71)",
"Tennessee Orange": "rgb(254, 149, 76)",
"Scarlet Red": "rgb(184, 21, 52)",
"Lime": "rgb(138, 210, 111)",
"Electric Blue": "rgb(0, 110, 179)",
"Emerald": "rgb(19, 50, 43)",
"Emerald Triblend": "rgb(23, 63, 53)", 
"Espresso": "rgb(57, 45, 43)",
"Evergreen": "rgb(17, 87, 64)",
"Forest": "rgb(39, 59, 51)",
"Forest Green": "rgb(34, 139, 34)",
"French Vanilla": "rgb(241, 225, 155)",
"Fuchsia": "rgb(219, 10, 91)",
"Garnet": "rgb(125, 41, 53)",
"Gold": "rgb(255, 215, 0)",
"Granite": "rgb(141, 144, 129)",
"Graphite Heather": "rgb(112, 115, 114)",
"Grass Green": "rgb(66, 124, 102)",
"Green": "rgb(96, 176, 102)",
"Grey": "rgb(50, 51, 49)",
"Grey Acid Fleece": "rgb(37, 40, 42)",
"Grey Acid Wash": "rgb(37, 40, 42)",
"Grey Triblend": "rgb(123, 125, 114)",
"Heather Aqua": "rgb(72, 169, 197)",
"Heather Autumn": "rgb(166, 102, 70)",
"Heather Baby Blue": "rgb(131, 176, 193)",
"Heather Blue": "rgb(142, 159, 188)",
"Heather Blue Storm": "rgb(127, 132, 135)",
"Heather Cement": "rgb(230, 221, 218)",
"Heather Cool Grey": "rgb(217, 207, 206)",
"Heather Dark Lavender": "rgb(166, 151, 188)",
"Heather Raspberry": "rgb(155, 64, 81)",
"Heather Silver": "rgb(204, 205, 200)",
"Heather Stone": "rgb(166, 155, 154)",
"Heather Storm": "rgb(139, 134, 140)",
"Heather Royal": "rgb(111, 152, 216)", 
"Heather Irish Green": "rgb(4, 152, 102)",
"Cigar": "rgb(122, 103, 89)",
"Bright Pink": "rgb(255, 128, 140)",
"Greystone": "rgb(136, 140, 133)",
"Heather Granite": "rgb(94, 94, 94)",
"Pacific Blue": "rgb(55, 107, 137)",
"Atlantic Blue": "rgb(51, 89, 108)",
"Heather Steel": "rgb(150, 150, 150)",
"Hunter Green": "rgb(65, 76, 72)",
"Solid Asphalt Blend": "rgb(78, 78, 78)",
"Solid Black Blend": "rgb(27, 27, 27)",
"Solid Navy Blend": "rgb(30, 39, 57)",
"Solid Red Blend": "rgb(178, 43, 36)",
"Solid True Royal Blend": "rgb(67, 83, 153)",
"Solid White Blend": "rgb(250, 250, 250)",
"Blue Storm": "rgb(126, 130, 133)",
"Light Violet": "rgb(214, 189, 202)",
"Storm": "rgb(154, 143, 154)",
"Thyme": "rgb(193, 196, 177)",
"Vintage Brown": "rgb(143, 110, 89)",
"Charcoal Black Slub": "rgb(48, 47, 52)",
"Solid Black Slub": "rgb(19, 19, 19)",
  "Heather Blue Lagoon": "rgb(134, 161, 169)",
  "Heather Brown": "rgb(94, 75, 60)",
  "Heather Bubble Gum": "rgb(248, 163, 188)",
  "Heather Canvas Red": "rgb(191, 13, 62)",
  "Heather Cardinal": "rgb(147, 41, 56)",
  "Heather Carolina Blue": "rgb(139, 170, 212)",
  "Heather Charity Pink": "rgb(225, 111, 143)",
  "Heather Clay": "rgb(162, 104, 89)",
  "Heather Columbia Blue": "rgb(101, 139, 204)",
  "Heather Dark Green": "rgb(67, 105, 91)",
  "Heather Dark Maroon": "rgb(175, 123, 136)",
  "Heather Dark Navy": "rgb(89, 84, 120)",
  "Heather Deep Royal": "rgb(29, 79, 145)",
  "Heather Deep Teal": "rgb(52, 101, 127)",
  "Heather Dust": "rgb(205, 198, 189)",
  "Heather Dusty Blue": "rgb(155, 178, 162)",
  "Heather Emerald": "rgb(19, 50, 43)",
  "Heather Forest": "rgb(27, 77, 40)",
  "Heather French Vanilla": "rgb(241, 225, 155)",
  "Heather Gold": "rgb(255, 163, 0)",
  "Heather Grass Green": "rgb(66, 124, 102)",
  "Heather Green": "rgb(121, 134, 60)",
  "Heather Ice Blue": "rgb(196, 225, 222)",
  "Heather Kelly": "rgb(0, 150, 94)",
  "Heather Lapis": "rgb(92, 97, 157)",
  "Heather Magenta": "rgb(148, 78, 135)",
  "Heather Marmalade": "rgb(255, 160, 16)",
  "Heather Maroon": "rgb(91, 43, 66)",
  "Heather Mauve": "rgb(163, 109, 106)",
  "Heather Midnight Navy": "rgb(49, 53, 70)",
  "Heather Military Green": "rgb(91, 97, 75)",
  "Heather Mint": "rgb(168, 213, 186)",
  "Heather Mustard": "rgb(198, 151, 63)",
  "Heather Natural": "rgb(233, 219, 179)",
  "Heather Navy": "rgb(47, 53, 80)",
  "Heather Oatmeal": "rgb(209, 204, 189)",
  "Heather Olive": "rgb(127, 116, 87)",
  "Heather Orange": "rgb(255, 106, 57)",
  "Heather Orchid": "rgb(176, 135, 155)",
  "Heather Peach": "rgb(243, 190, 141)",
  "Heather Pink": "rgb(247, 206, 215)",
  "Heather Pink Gravel": "rgb(197, 170, 156)",
  "Heather Prism Blue": "rgb(165, 179, 204)",
  "Heather Prism Dusty Blue": "rgb(155, 178, 162)",
  "Heather Prism Ice Blue": "rgb(186, 209, 190)",
  "Heather Prism Lilac": "rgb(199, 161, 178)",
  "Heather Prism Mint": "rgb(160, 218, 179)",
  "Heather Prism Natural": "rgb(210, 207, 196)",
  "Heather Prism Peach": "rgb(234, 190, 176)",
  "Heather Prism Sunset": "rgb(236, 152, 101)",
  "Heather Purple": "rgb(131, 105, 149)",
  "Heather Red": "rgb(191, 13, 62)",
  "Heather Sage": "rgb(149, 166, 159)",
  "Heather Sand Dune": "rgb(191, 163, 135)",
  "Heather Sea Green": "rgb(0, 186, 179)",
  "Heather Slate": "rgb(88, 105, 117)",
  "Heather Soft Cream": "rgb(222, 203, 153)",
  "Heather Sunset": "rgb(234, 147, 109)",
  "Heather Tan": "rgb(191, 186, 155)",
  "Heather Team Purple": "rgb(125, 85, 199)",
  "Heather True Royal": "rgb(36, 80, 154)",
  "Heather Yellow": "rgb(252, 234, 118)",
  "Heather Yellow Gold": "rgb(253, 210, 110)",
  "Heliconia": "rgb(219, 62, 121)",
  "Ice Blue": "rgb(196, 225, 222)",
  "Indigo Blue": "rgb(72, 109, 135)",
  "Saddle": "rgb(151, 95, 68)",
  "Grey Heather": "rgb(197, 198, 203)",
  "Dusty Sage": "rgb(175, 186, 179)",
  "Storm Blue": "rgb(94, 106, 124)",
  "Safety Yellow": "rgb(209, 230, 114)",
  "Royal Heather": "rgb(69, 104, 169)",
      "Athletic Royal": "rgb(25, 82, 194)",
  "Athletic Teal": "rgb(0, 144, 153)",
  "Athletic Gold": "rgb(238, 201, 131)",
  "Athletic Navy": "rgb(55, 59, 87)",
     "Army Brown": "rgb(116, 107, 90)",
       "Blue Horizon": "rgb(151, 203, 230)",
  "Candy Orange": "rgb(255, 182, 153)",
  "Daffodil Yellow": "rgb(238, 204, 136)",
  "Charisma Coral": "rgb(255, 127, 127)",
  "Lemon Meringue": "rgb(230, 224, 185)",
  "Poppy Red": "rgb(243, 85, 66)",
  "Green Clay": "rgb(94, 137, 140)",
  "Regal Navy": "rgb(30, 52, 127)",
  "Grape Smash Heather": "rgb(94, 60, 122)",
  "Athletic Red": "rgb(220, 18, 29)",
  "Athletic Purple": "rgb(78, 48, 128)",
  "Athletic Crimson": "rgb(204, 0, 51)",
  "Athletic Cardinal": "rgb(139, 27, 44)",
  "Athletic Dark Green": "rgb(47, 79, 79)",
"Wow Pink": "rgb(255, 78, 172)",
  "Pale Pink": "rgb(240, 210, 213)",
  "Clean Mint": "rgb(175, 237, 218)",
  "Fatigue Green": "rgb(117, 107, 73)",
  "Smoke Grey": "rgb(94, 85, 90)",
  "Athletic Yellow": "rgb(238, 201, 23)",
  "Denim Blue": "rgb(89, 128, 172)",
  "Oxford Grey": "rgb(122, 122, 122)",
  "Stonewashed Green": "rgb(160, 185, 179)",
  "Stonewashed Blue": "rgb(122, 140, 160)",
  "Kelly Green Heather": "rgb(31, 140, 109)",
  "Gunmetal Heather": "rgb(94, 94, 94)",
  "Light Yellow": "rgb(255, 239, 192)",
  "Forest Camo": "rgb(48, 70, 60)",
"Army Heather": "rgb(101, 99, 74)",
      "Deep Red": "rgb(151, 0, 56)",
  "Light Steel": "rgb(178, 185, 188)",
  "Deep Forest": "rgb(30, 66, 49)",
  "Classic Navy": "rgb(47, 50, 65)",
  "Blue Aqua": "rgb(187, 230, 243)",
  "Black Camo": "rgb(74, 69, 72)",
  "Alpine Green": "rgb(64, 85, 77)",
  "Classic Navy Heather": "rgb(60, 65, 79)",
  "Dusty Pink": "rgb(212, 172, 175)",
  "Irish Green": "rgb(0, 158, 96)",
  "Kelly": "rgb(0, 122, 83)",
  "Kelly Green": "rgb(4, 106, 56)",
  "Lapis": "rgb(92, 97, 157)",
  "Lavender Blue": "rgb(107, 128, 162)",
  "Lavender Dust": "rgb(225, 215, 216)",
  "Leaf": "rgb(101, 146, 86)",
  "Light Blue": "rgb(173, 216, 230)",
  "Light Pink": "rgb(255, 182, 193)",
  "Lilac": "rgb(209, 172, 206)",
  "Maize Yellow": "rgb(246, 208, 58)",
  "Marine": "rgb(0, 127, 163)",
  "Maroon": "rgb(91, 43, 66)",
  "Maroon Marble": "rgb(106, 44, 62)",
  "Maroon Triblend": "rgb(131, 83, 98)",
  "Mauve": "rgb(163, 109, 106)",
  "Midnight": "rgb(31, 42, 68)",
  "Midnight Navy": "rgb(49, 53, 70)",
  "Military Green": "rgb(80, 87, 62)",
  "Mint": "rgb(160, 218, 179)",
  "Mint Green": "rgb(152, 255, 152)",
  "Mustard": "rgb(198, 151, 63)",
  "Natural": "rgb(223, 209, 167)",
  "Navy": "rgb(0, 0, 128)",
  "Navy Marble": "rgb(27, 54, 93)",
  "Navy Speckled": "rgb(28, 31, 42)",
  "Navy Triblend": "rgb(62, 75, 101)",
  "Neon Blue": "rgb(0, 139, 204)",
  "Neon Green": "rgb(68, 214, 44)",
  "Neon Orange": "rgb(255, 103, 31)",
  "Neon Pink": "rgb(255, 133, 189)",
  "Neon Yellow": "rgb(236, 241, 102)",
  "Oatmeal": "rgb(209, 204, 189)",
  "Oatmeal Triblend": "rgb(190, 174, 154)",
  "Ocean Blue": "rgb(98, 168, 193)",
  "Old Gold": "rgb(207, 181, 59)",
  "Olive": "rgb(65, 72, 35)",
  "Orange": "rgb(244, 99, 58)",
  "Orange Triblend": "rgb(255, 141, 109)",
  "Orchid": "rgb(219, 196, 225)",
  "Oxblood Black": "rgb(63, 37, 55)",
  "Peach": "rgb(243, 190, 141)",
  "Pebble": "rgb(133, 120, 116)",
  "Pebble Brown": "rgb(133, 120, 116)",
  "Pine": "rgb(66, 94, 90)",
  "Pink": "rgb(255, 192, 203)",
  "Pink Gravel": "rgb(197, 170, 156)",
  "Plum": "rgb(74, 48, 65)",
  "Poppy": "rgb(225, 6, 0)",
  "Purple": "rgb(128, 0, 128)",
  "Purple Triblend": "rgb(97, 75, 121)",
  "Purple Storm": "rgb(132, 110, 113)",
  "Red": "rgb(255, 0, 0)",
  "Vintage Red": "rgb(221, 89, 102)",
  "Vintage Denim": "rgb(121, 139, 151)",
  "Red Acid Wash": "rgb(191, 13, 62)",
  "Red Marble": "rgb(192, 20, 60)",
  "Red Speckled": "rgb(157, 34, 53)",
  "Royal": "rgb(65, 105, 225)",
  "Royal Purple": "rgb(106, 69, 147)",
  "Rust": "rgb(158, 72, 63)",
  "Safety Green": "rgb(198, 239, 106)",
  "Safety Orange": "rgb(255, 103, 0)",
  "Safety Pink": "rgb(255, 112, 166)",
  "Sage": "rgb(151, 167, 152)",
  "Sand": "rgb(194, 178, 128)",
  "Sand Dune": "rgb(195, 157, 136)",
  "Sapphire": "rgb(15, 82, 186)",
  "Sea Green": "rgb(0, 186, 179)",
  "Seafoam Blue": "rgb(161, 211, 211)",
  "Silver": "rgb(199, 201, 199)",
  "Slate": "rgb(88, 105, 117)",
  "Soft Cream": "rgb(222, 203, 153)",
  "Soft Pink": "rgb(238, 217, 212)",
  "Sport Grey": "rgb(151, 153, 155)",
  "Spring Green": "rgb(222, 226, 159)",
  "Steel Blue": "rgb(95, 132, 156)",
  "Stone": "rgb(131, 122, 88)",
  "Strobe": "rgb(231, 227, 109)",
  "Sunset": "rgb(230, 142, 94)",
  "Synthetic Green": "rgb(43, 174, 102)",
  "Tan": "rgb(175, 161, 124)",
  "Teal": "rgb(0, 191, 179)",
  "Teal Triblend": "rgb(0, 115, 119)",
  "Team Navy": "rgb(43, 62, 133)",
  "Team Purple": "rgb(46, 26, 71)",
  "Terracotta": "rgb(180, 106, 85)",
  "Texas Orange": "rgb(203, 96, 21)",
  "Toast": "rgb(158, 106, 56)",
  "True Royal": "rgb(59, 97, 166)",
  "True Royal Acid Wash": "rgb(29, 79, 145)",
  "True Royal Marble": "rgb(27, 81, 150)",
  "True Royal Triblend": "rgb(36, 80, 154)",
  "Turquoise": "rgb(0, 175, 215)",
  "Vintage Black": "rgb(33, 35, 34)",
  "Vintage Navy": "rgb(69, 93, 107)",
  "Vintage White": "rgb(223, 221, 215)",
  "Violet": "rgb(238, 130, 238)",
  "White": "rgb(255, 255, 255)",
  "White Fleck Triblend": "rgb(217, 217, 214)",
  "White Marble": "rgb(200, 201, 199)",
  "White Slub": "rgb(241, 242, 241)",
  "Yellow": "rgb(252, 234, 118)",
  "Antique Cherry Red": "rgb(158, 31, 31)",
  "Athletic Heather/ White": {
    image: "https://transferkingdom.com/cdn/shop/files/37055_f_fm_d9c828d8-ceaf-4834-baee-9cf930cb8f95_large.jpg"
  },
              "Forest Marble": {
    image: "https://transferkingdom.com/cdn/shop/files/66294_f_fm_e1d6cfcf-6387-4e0d-8fdc-0978fd69ce05_large.jpg"
  },
      "Blonde": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blonde.jpg?v=1751920484"
  },
      "Acadia": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Acadia.jpg?v=1752684068"
  },
      "Aurora": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Aurora.jpg?v=1752684068"
  },
      "Barbados": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Barbados.jpg?v=1752684067"
  },
      "Black Shibori": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_Shibori.jpg?v=1752684068"
  },
      "Blast": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blast.jpg?v=1752684067"
  },
      "Blaze": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blaze.jpg?v=1752684068"
  },
      "Blue Jerry": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blue_Jerry.jpg?v=1752684068"
  },
      "Blue Ocean": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Blue_Ocean.jpg?v=1752684067"
  },
      "Camo Swirl": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Camo_Swirl.jpg?v=1752684068"
  },
      "Carnival": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Carnival.jpg?v=1752684068"
  },
      "Cherry Cola": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cherry_Cola.jpg?v=1752684068"
  },
      "Coral Reef": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Coral_Reef.jpg?v=1752684068"
  },
      "Cotton Candy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cotton_Candy.jpg?v=1752684068"
  },
      "Desert Rose": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Desert_Rose_61ee3638-19ec-44fd-8a8d-c54057c18c0f.jpg?v=1752684068"
  },
      "Dharma": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dharma.jpg?v=1752684067"
  },
      "Earth": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Earth.jpg?v=1752684067"
  },
      "Eternity": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Eternity_c20a71dc-a064-4a8f-b049-24752077db4a.jpg?v=1752684067"
  },
      "Evening Sky": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Evening_Sky.jpg?v=1752684067"
  },
      "Everglades": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Everglades.jpg?v=1752684067"
  },
      "Ferris Wheel": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ferris_Wheel.jpg?v=1752684068"
  },
      "Fire": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Fire.jpg?v=1752684067"
  },
      "Fire Cracker": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Fire_Cracker.jpg?v=1752684068"
  },
      "Flag": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Flag.jpg?v=1752684067"
  },
      "Flashback": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Flashback_7570da31-8326-4c3f-b028-10b570c20355.jpg?v=1752684067"
  },
      "Flo Blue/ Pink": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Flo_Blue_Pink.jpg?v=1752684067"
  },
      "Fluorescent Swirl": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Fluorescent_Swirl.jpg?v=1752684067"
  },
      "Funnel Cake": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Funnel_Cake.jpg?v=1752684067"
  },
      "Glacier": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Glacier.jpg?v=1752684068"
  },
      "Grand Canyon": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grand_Canyon.jpg?v=1752684067"
  },
      "Gum Drop": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Gum_Drop.jpg?v=1752684067"
  },
      "Gummy Bear": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Gummy_Bear.jpg?v=1752684067"
  },
      "Harmony": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Harmony.jpg?v=1752684068"
  },
      "Hypnotize": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Hypnotize.jpg?v=1752684067"
  },
      "Independence": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Independence.jpg?v=1752684068"
  },
      "Jamberry": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Jamberry.jpg?v=1752684068"
  },
      "Jellybean": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Jellybean.jpg?v=1752684067"
  },
      "Karma": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Karma.jpg?v=1752684068"
  },
      "Lava Lamp": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lava_Lamp.jpg?v=1752684067"
  },
      "Lollypop": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lollypop.jpg?v=1752684067"
  },
      "Magic": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Magic.jpg?v=1752684067"
  },
      "Mardi Gras": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mardi_Gras.jpg?v=1752684067"
  },
      "Mint Fusion": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mint_Fusion.jpg?v=1752684067"
  },
      "Minty Rainbow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Minty_Rainbow.jpg?v=1752684067"
  },
      "Moonbeam": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Moonbeam.jpg?v=1752684067"
  },
      "Moondance": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Moondance.jpg?v=1752684067"
  },
      "Multi Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multi_Black.jpg?v=1752682763"
  },
      "Multi Blue": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multi_Blue_a99cb57c-5355-4ab6-b989-a2eb38e6cc86.jpg?v=1752684067"
  },
      "Multi Rainbow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Multi_Rainbow.jpg?v=1752684067"
  },
      "Neon Blueberry": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Neon_Blueberry.jpg?v=1752684068"
  },
      "Neon Bubblegum": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Neon_Bubblegum.jpg?v=1752684067"
  },
      "Neon Rainbow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Neon_Rainbow_16410395-e33f-4b19-88c4-ab710cf818e8.jpg?v=1752684067"
  },
      "Prism": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Prism_8eade0d3-f61b-4adb-9b46-9759f2614350.jpg?v=1752684067"
  },
      "Quest": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Quest.jpg?v=1752684067"
  },
      "Rasta Web": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rasta_Web.jpg?v=1752684067"
  },
      "Reactive Rainbow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Reactive_Rainbow.jpg?v=1752684067"
  },
      "Saint Lucia": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Saint_Lucia.jpg?v=1752684068"
  },
      "Saturn": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Saturn.jpg?v=1752684067"
  },
      "Serenity": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Serenity.jpg?v=1752684067"
  },
      "Sherbet": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sherbet.jpg?v=1752684067"
  },
      "Slushy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Slushy.jpg?v=1752684067"
  },
      "Snow Cone": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Snow_Cone.jpg?v=1752684067"
  },
      "Spider Baby Blue": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Baby_Blue.jpg?v=1752684067"
  },
      "Spider Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Black.jpg?v=1752687210"
  },
      "Spider Burgundy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Burgundy.jpg?v=1752684067"
  },
      "Spider Crimson": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Crimson.jpg?v=1752684067"
  },
      "Spider Dandelion": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Dandelion.jpg?v=1752684067"
  },
      "Spider Gold": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Gold.jpg?v=1752684067"
  },
      "Spider Green": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Green.jpg?v=1752684067"
  },
      "Spider Grey": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Grey.jpg?v=1752684067"
  },
      "Spider Kelly": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Kelly.jpg?v=1752684067"
  },
      "Spider Lavender": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Lavender.jpg?v=1752684067"
  },
      "Spider Lime": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Lime.jpg?v=1752684067"
  },
      "Spider Mint": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Mint.jpg?v=1752684067"
  },
      "Spider Navy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Navy.jpg?v=1752684067"
  },
      "Spider Orange": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Orange.jpg?v=1752684067"
  },
      "Spider Pink": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Pink.jpg?v=1752684067"
  },
      "Spider Purple": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Purple.jpg?v=1752684068"
  },
      "Spider Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Red.jpg?v=1752684067"
  },
      "Spider Royal": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Royal.jpg?v=1752684067"
  },
      "Spider Silver": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Silver.jpg?v=1752684067"
  },
      "Spider Turquoise": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Spider_Turquoise.jpg?v=1752684067"
  },
      "Sunflower": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sunflower.jpg?v=1752684067"
  },
      "Swirl Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Swirl_Black.jpg?v=1752687569"
  },
      "Swirl Blue": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Swirl_Blue.jpg?v=1752684067"
  },
      "Swirl Purple": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Swirl_Purple.jpg?v=1752684068"
  },
      "Swirl Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Swirl_Red.jpg?v=1752684067"
  },
      "Unicorn": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Unicorn.jpg?v=1752684067"
  },
      "Union Jack": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Union_Jack.jpg?v=1752684068"
  },
      "Voodoo": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Voodoo.jpg?v=1752684067"
  },
      "White/ Turquoise": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White_Turquoise.jpg?v=1752684067"
  },
      "Wild Spider": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Wild_Spider.jpg?v=1752684068"
  },
      "Willow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Willow.jpg?v=1752684068"
  },
      "Woodstock": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Woodstock.jpg?v=1752684067"
  },
      "Yellowstone": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Yellowstone.jpg?v=1752684067"
  },
      "Yosemite": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Yosemite.jpg?v=1752684067"
  },
      "Mystique": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mystique.jpg?v=1752687907"
  },
      "Dream": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dream.jpg?v=1752687908"
  },
      "Zen Rainbow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Zen_Rainbow.jpg?v=1752684067"
  },
      "Zero G": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Zero_G.jpg?v=1752684067"
  },
      "Clay Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Clay_Red.jpg?v=1751922200"
  },
      "Mocha": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mocha.jpg?v=1751922200"
  },
      "Pastel Purple": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Pastel_Purple.jpg?v=1751922200"
  },
      "Shadow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shadow.jpg?v=1751922201"
  },
       "Powder Pink": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Powder_Pink.jpg?v=1751921943"
  },
      "Charcoal Grey Heather": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal_Grey_Heather.jpg?v=1751920484"
  },
      "Cream Blue": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Cream_Blue.jpg?v=1751920484"
  },
      "Sky Blue": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sky_Blue.jpg?v=1751920484"
  },
      "Tiffany Blue": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tiffany_Blue.jpg?v=1751920484"
  },
              "Black Leopard": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Leopard_5ed2d66d-5d27-48ff-93cb-37509aa9f19a.jpg?v=1751406408"
  },
      
       "Black Reptile": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Reptile.jpg?v=1751406408"
  },
             "Brown Leopard": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown-Leopard.jpg?v=1751406408"
  },
             "Brown Reptile": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Brown-Reptile.jpg?v=1751406408"
  },
             "Green Reptile": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Green-Reptile.jpg?v=1751406408"
  },
             "Lilac Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lilac-Stripe.jpg?v=1751406408"
  },
             "Marine Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Marine-Stripe.jpg?v=1751406408"
  },
             "Mauvelous Spot": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Mauvelous-Spot_2bec79ac-6fe7-43d5-8700-980745023907.jpg?v=1751406408"
  },
             "Natural Camo": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Camo.jpg?v=1751406408"
  },
             "Natural Leopard": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Natural-Leopard.jpg?v=1751406408"
  },
             "Rainbow Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Rainbow-Stripe_dfb6efbc-a72f-4a91-aa2b-d863f51dcd7a.jpg?v=1751406408"
  },
      "Ballerina/ Mauvelous": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ballerina--Mauvelous.jpg?v=1751408563"
  },
      "Ballerina/ White Dot": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ballerina-White-Dot.jpg?v=1751408563"
  },
      "Black/ White Dot": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black_White_Dot.jpg?v=1751408563"
  },
      "Chill/ Indigo": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Chill-Indigo.jpg?v=1751408562"
  },
      "Granite Heather/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Granite-Heather-Black.jpg?v=1751408563"
  },
      "Kelly/ White Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Kelly-White-Stripe.jpg?v=1751408563"
  },
      "Lavender/ Purple": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Lavender-Purple.jpg?v=1751408563"
  },
      "Titanium/ Natural Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Titanium-Natural-Stripe.jpg?v=1751408563"
  },
             "Shadow Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Shadow-Stripe_4ed8758a-e24d-47d1-8c5c-82b3b27ab667.jpg?v=1751406408"
  },
             "Slate Spot": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Slate-Spot.jpg?v=1751406408"
  },
             "Storm Camo": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Storm-Camo.jpg?v=1751402014"
  },
      "Haze Tie Dye": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Haze-Tie-Dye_5d3a7fcb-6909-4abe-a68b-452ccec134c7.jpg?v=1751407666"
  },
      "Ice Blackout": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Ice-Blackout.jpg?v=1751407666"
  },
      "Island Tie Dye": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Island-Tie-Dye_8d344ddd-aff4-415a-8853-d702e0c01439.jpg?v=1751407666"
  },
      "Sangria Blackout": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sangria-Blackout.jpg?v=1751407665"
  },
             "Sunkissed Stripe": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Sunkissed-Stripe.jpg?v=1751406408"
  },
             "Tradewind Spot": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Tradewind-Spot_962e3e82-3565-4ebb-be64-7418b7b42650.jpg?v=1751406408"
  },
             "Vintage Camo": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-Camo_823686ac-acfc-4575-a354-bb8a8e0b25a1.jpg?v=1751406408"
  },
             "White Reptile": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Reptile.jpg?v=1751406408"
  },
             "White Spot": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Spot_8d6e47dc-198d-4f2e-a3bb-51856ed330f5.jpg?v=1751406407"
  },
       "Heather Denim/ Navy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Denim--Navy.jpg?v=1750459351"
  },
       "Heather Grey/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey--Black.jpg?v=1750459351"
  },
       "Heather Grey/ Heather Charcoal": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey--Heather-Charcoal.jpg?v=1750459351"
  },
       "Heather Grey/ Heather Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey--Heather-Red.jpg?v=1750459351"
  },
       "Heather Grey/ Navy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Heather-Grey--Navy.jpg?v=1750459352"
  },
       "Vintage White/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-White--Black.jpg?v=1750459351"
  },
       "Vintage White/ Inked India": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-White-Inked-India.jpg?v=1750459351"
  },
       "Vintage White/ Mellow Yellow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-White-Mellow-Yellow.jpg?v=1750459351"
  },
       "Vintage White/ Rio Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Vintage-White-Rio-Red.jpg?v=1750459351"
  },
       "White/ Heather Charcoal": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black--Heather-Charcoal.jpg?v=1750459351"
  },
       "White/ Heather Denim": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Denim.jpg?v=1750459351"
  },
       "White/ Royal": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Royal.jpg?v=1750459351"
  },
                "Mauve Marble": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/mauve-marble.jpg"
  },
                     "White Marble": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Marble.jpg?v=1749843856"
  }, 
                          "Black Acid Wash": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Acid-Wash.jpg"
  }, 
                                "Denim Slub": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Denim-Slub.jpg?v=1749843805"
  }, 
       "Charcoal Marble": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Charcoal-Marble.gif?v=1750265640"
  }, 
                                "Navy Slub": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Navy-Slub.jpg?v=1749843722"
  }, 
      "Black Heather/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Heather-Black.gif?v=1750006417"
  }, 
      "Black Marble/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Marble-Black.gif?v=1750006418"
  }, 
       "Black/ Deep Heather": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Deep-Heather.gif?v=1750006417"
  }, 
     "White/ Denim": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Denim2.jpg?v=1749844663"
  },
      "Athletic Heather/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather-Black.jpg?v=1750275857"
  },
      "Athletic Heather/ Navy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Athletic-Heather--Navy.jpg?v=1750275150"
  },
      "Grey/ Maroon Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Maroon-Triblend.gif?v=1750005359"
  }, 
      "Grey/ Maroon Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Maroon-Triblend.gif?v=1750005359"
  },
       "Dark Grey/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Dark-Grey-Black.jpg?v=1750276974"
  }, 
       "White/ Heather Peach": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Peach.gif?v=1750005359"
  }, 
       "White/ True Royal": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-True-Royal.gif?v=1750005359"
  }, 
       "White/ Kelly": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Kelly.gif?v=1750005359"
  }, 
       "White/ Maroon": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Maroon.gif?v=1750005359"
  }, 
       "White/ Navy": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Navy_28adae0a-ad8e-4406-8f40-dde52bb12ed5.gif?v=1750005359"
  }, 
       "White/ Neon Orange": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Orange.gif?v=1750005359"
  }, 
       "White/ Neon Pink": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Pink.gif?v=1750005359"
  }, 
       "White/ Neon Yellow": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Neon-Yellow.gif?v=1750005359"
  }, 
       "White/ Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Red.gif?v=1750005359"
  }, 
       "White/ Denim": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Denim.gif?v=1750005359"
  }, 
       "White/ Heather Olive": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Heather-Olive.gif?v=1750005359"
  }, 
       "Grey/ Red Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Red-Triblend.gif?v=1750005359"
  }, 
       "Grey/ True Royal Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-True-Royal-Triblend.gif?v=1750005359"
  }, 
       "White Fleck/ Charcoal Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Fleck--Charcoal-Triblend.gif?v=1750005359"
  }, 
       "White Fleck/ Navy Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Fleck-Navy-Triblend.gif?v=1750005359"
  }, 
       "White/ Asphalt": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Asphalt.gif?v=1750005359"
  }, 
       "Black/ Red": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-Red.gif?v=1750006417"
  }, 
       "Black/ True Royal": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-True-Royal.gif?v=1750006418"
  }, 
       "Black/ White": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Black-White.gif?v=1750005359"
  }, 
       "Deep Heather/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Deep-Heather--Black.gif?v=1750005359"
  }, 
       "Grey/ Charcoal Black Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey--Charcoal-Black-Triblend.gif?v=1750005359"
  }, 
       "Grey/ Emerald Triblend": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/Grey-Emerald-Triblend.gif?v=1750005359"
  }, 
       "White/ Black": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White-Black.jpg?v=1749844746"
  }, 
       "White/ Deep Heather": {
    image: "https://cdn.shopify.com/s/files/1/0651/6300/2098/files/White--Deep-Heather.gif?v=1750005359"
  }, 
  "Antique Sapphire": "rgb(40, 96, 145)",
  "Azalea": "rgb(255, 182, 193)",
  "Cardinal Red": "rgb(196, 30, 58)",
  "Cherry Red": "rgb(172, 43, 55)",
  "Dark Chocolate": "rgb(86, 57, 33)",
  "Heather Scarlet Red": "rgb(184, 58, 75)",
  "Solid Athletic Grey": "rgb(186, 188, 192)"
    };
    this.init();
  }

  init() {
    this.loadProductsData();
    this.initColorButtons();
    this.initQuantityInputs();
    this.initAddToCart();
    this.applyColorSwatches();
  }

 applyColorSwatches() {
  const colorButtons = document.querySelectorAll('.color-button');
  colorButtons.forEach(button => {
    const color = button.dataset.color;
    const swatch = button.querySelector('.color-swatch2');
    const colorData = this.colorMap[color];

    if (typeof colorData === 'string') {
      // Use color code
      swatch.style.backgroundColor = colorData;
      swatch.style.backgroundImage = '';
    } else if (colorData?.image) {
      // Resim kullan
      swatch.style.backgroundColor = 'transparent';
      swatch.style.backgroundImage = `url(${colorData.image})`;
      swatch.style.backgroundSize = 'cover';
      swatch.style.backgroundPosition = 'center';
    } else {
      swatch.innerHTML = `<span class="color-text">${color}</span>`;
    }
  });
}


  loadProductsData() {
    const sizeBoxes = document.querySelectorAll('.size-box');
    sizeBoxes.forEach(box => {
      const productId = box.dataset.productId;
      const variantsData = box.dataset.variants;
      const inventoryData = box.dataset.inventory;

      try {
        const variants = JSON.parse(variantsData);
        this.productsData[productId] = variants;

        if (inventoryData) {
          const inventoryPairs = inventoryData.split(',');
          inventoryPairs.forEach(pair => {
            const [variantId, quantity] = pair.split(':');
            this.variantStocks[variantId] = parseInt(quantity) || 0;
          });
        }
      } catch (error) {
        console.error('Error loading product data:', error);
      }
    });
  }

  initColorButtons() {
    const colorButtons = document.querySelectorAll('.color-button');
    colorButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const clickedButton = e.currentTarget;
        const color = clickedButton.dataset.color;
        const imageUrl = clickedButton.dataset.imageUrl;
        
        this.selectedColor = color;
        this.updateSelectedColorUI(color);
        this.updateProductImage(imageUrl);
        
        document.querySelectorAll('.color-button').forEach(btn => 
          btn.classList.remove('selected'));
        clickedButton.classList.add('selected');

        this.updatePricesAndStock();
      });
    });

    if (colorButtons.length > 0) {
      colorButtons[0].click();
    }
  }

  updateSelectedColorUI(color) {
    const colorName = document.querySelector('.color-name');
    if (colorName) {
      colorName.textContent = color;
    }
  }

  updateProductImage(imageUrl) {
    if (imageUrl && this.mainImage) {
      this.mainImage.src = imageUrl;
    }
  }

  updatePricesAndStock() {
    const sizeBoxes = document.querySelectorAll('.size-box');
    
    sizeBoxes.forEach(box => {
      const productId = box.dataset.productId;
      const variants = this.productsData[productId];
      
      if (!variants) {
        console.error('No variants found for product:', productId);
        return;
      }
      
      const variant = variants.find(v => 
        v && v.option1 && v.option1.toLowerCase() === this.selectedColor.toLowerCase()
      );
      
      if (variant) {
        box.style.display = 'flex';
        const quantityControl = box.querySelector('.quantity-control');
        const size = box.querySelector('.size-label').textContent;
        const inventory = this.variantStocks[variant.id] || 0;

        console.log(`Stock for ${size} ${this.selectedColor}: ${inventory}`);

        box.querySelector('.price').textContent = this.formatMoney(variant.price);

        if (inventory > 0) {
          quantityControl.innerHTML = `
            <input type="number" 
                   class="quantity-input"
                   data-size="${size}"
                   data-variant-id="${variant.id}"
                   min="0"
                   max="${inventory}"
                   value="0">
            <div class="stock">${inventory}</div>
          `;
        } else {
          quantityControl.innerHTML = `
            <div class="out-of-stock">Out of Stock</div>
          `;
        }
      } else {
        box.style.display = 'none';
      }
    });

    this.initQuantityInputs();
  }

  initQuantityInputs() {
    const inputs = document.querySelectorAll('.quantity-input');
    inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        const size = e.target.dataset.size;
        const quantity = parseInt(e.target.value) || 0;
        this.quantities[size] = quantity;
      });
    });
  }

async addToCart() {
  if (!this.selectedColor) {
    alert('Please select a color');
    return;
  }

  const items = [];
  const sizeBoxes = document.querySelectorAll('.size-box');
  const vendor = document.querySelector('.vendor').textContent.trim();
  
  for (const box of sizeBoxes) {
    const quantityInput = box.querySelector('.quantity-input');
    
    if (quantityInput) {
      const quantity = parseInt(quantityInput.value) || 0;
      const variantId = quantityInput.dataset.variantId;
      
      if (quantity > 0 && variantId) {
        items.push({
          id: variantId,
          quantity: quantity,
          properties: {
            '_vendor': vendor, // Checkout'ta gizli olması için _ ile başlıyoruz
            'Brand': vendor   // Cart'ta görünmesi için normal property
          }
        });
      }
    }
  }

  if (items.length === 0) {
    alert('Please select at least one product quantity');
    return;
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });
    
    // Cart updated event'ini dispatch et
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }

  } catch (error) {
    console.error('Failed to add items to cart:', error);
    alert('Failed to add items to cart. Please try again.');
  }
}

  initAddToCart() {
    const button = document.querySelector('.add-to-cart-button');
    button.addEventListener('click', () => this.addToCart());
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  }
}

// Global scope'a sınıfı ekle
window.BlanksProductManager = BlanksProductManager;

// Sayfa yüklendiğinde sınıfı başlat
document.addEventListener('DOMContentLoaded', () => {
  new BlanksProductManager();
});